interface ActivityItem {
  id: string;
  title: string;
  time: string;
  detail: string;
  status: 'completed' | 'in_progress' | 'pending';
}

const statusStyles: Record<ActivityItem['status'], string> = {
  completed: 'bg-success/20 text-success',
  in_progress: 'bg-warning/20 text-warning',
  pending: 'bg-muted text-muted-foreground'
};

export function RecentActivityList({ items }: { items: ActivityItem[] }): JSX.Element {
  return (
    <div className="glass-card divide-y divide-white/10">
      {items.map((item) => (
        <div key={item.id} className="flex items-center justify-between gap-4 px-4 py-3">
          <div>
            <p className="text-sm font-medium text-foreground">{item.title}</p>
            <p className="text-xs text-muted-foreground">{item.detail}</p>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs text-muted-foreground">{item.time}</span>
            <span className={`rounded-full px-2.5 py-1 text-xs font-medium ${statusStyles[item.status]}`}>
              {item.status.replace('_', ' ')}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
